import { ErrorLabel } from '@styles/shared-styles';
import * as React from 'react';

interface Props {
    condition: boolean;
    strict?: boolean;
}
export const ConditionalError: React.FunctionComponent<Props> = props => {
    const {
        condition,
        strict,
        children
    } = props;

    const failsStrictCheck = strict && condition !== true;
    const failsNonStrictCheck = !strict && !condition;

    if (failsStrictCheck || failsNonStrictCheck) {
        return null;
    }

    return (
        <ErrorLabel>{children}</ErrorLabel>
    );
};



// WEBPACK FOOTER //
// ./src/components/conditional-error/index.tsx